import React from 'react';
import AudioConfigContext from '.';

export default function useAudioConfigContext() {
  const context = React.useContext(AudioConfigContext);

  if (!context) {
    throw new Error('useAudioConfigContext must be used within a AudioConfigContextProvider');
  }
  return context;
}
